// extracted by mini-css-extract-plugin
export default {"home-container":"Home_home-container__sCZWl","server-padding-container":"Home_server-padding-container__4zKFt","center":"Home_center__ev1w-"};